import {EVENTS_OFFERING__GET} from "../actions";

export default function(state = {}, action) {

  switch (action.type) {
    case EVENTS_OFFERING__GET:
      //console.log('rdcr_user_events_offering -- EVENTS_OFFERING__GET -- action.payload', action.payload)
      return action.payload;
    default:
      return state;
  }
}
